// JsFromRoutes CacheKey 975e8ca0ab5d8d7def681558f95f88e9
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@corp/services/api'

export default {
  search: /* #__PURE__ */ definePathHelper('post', '/admin/consumer/category_module_links/search'),
  index: /* #__PURE__ */ definePathHelper('get', '/admin/consumer/category_module_links'),
  create: /* #__PURE__ */ definePathHelper('post', '/admin/consumer/category_module_links'),
  update: /* #__PURE__ */ definePathHelper('patch', '/admin/consumer/category_module_links/:id'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/admin/consumer/category_module_links/:id'),
}
